import React, { useEffect } from "react";

/**
 * Enhanced SEO Component for Omni-Search & AI Optimization.
 * Injects complex JSON-LD for Search Engines and LLMs (ChatGPT/Perplexity).
 */
const SEO = () => {
  useEffect(() => {
    // 1. Organization & Service Schema
    const orgJsonLd = {
      "@context": "https://schema.org",
      "@type": "Corporation",
      "name": "HARA-XY",
      "url": "https://hara-xy.com",
      "logo": "https://hara-xy.com/favicon.png",
      "description": "Enterprise IT Solutions & Consulting. Leading the digital frontier with Cloud transformation, custom software development, and AI-driven business strategy.",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Coimbatore",
        "addressRegion": "TN",
        "addressCountry": "IN"
      },
      "footer": {
         "@type": "WPFooter",
         "copyrightYear": 2026,
         "copyrightHolder": "HARA-XY"
      }
    };

    // 2. FAQ Schema (Crucial for AI Search & Rich Snippets)
    const faqJsonLd = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What services does HARA-XY provide?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "HARA-XY provides a comprehensive suite of Enterprise IT solutions, including Cloud Transformation, Custom Software Development, AI Strategy, and Digital Consulting."
          }
        },
        {
          "@type": "Question",
          "name": "Where is HARA-XY located?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "HARA-XY is headquartered in Coimbatore, Tamil Nadu, India, and serves clients globally with enterprise-grade IT services."
          }
        },
        {
          "@type": "Question",
          "name": "Does HARA-XY offer internship management?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, HARA-XY features a sophisticated Internship Management platform including certificate verification, talent pooling, and hiring automation."
          }
        }
      ]
    };

    const script1 = document.createElement("script");
    script1.type = "application/ld+json";
    script1.id = "org-schema";
    script1.innerHTML = JSON.stringify(orgJsonLd);
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.type = "application/ld+json";
    script2.id = "faq-schema";
    script2.innerHTML = JSON.stringify(faqJsonLd);
    document.head.appendChild(script2);

    return () => {
      const s1 = document.getElementById("org-schema");
      const s2 = document.getElementById("faq-schema");
      if (s1) document.head.removeChild(s1);
      if (s2) document.head.removeChild(s2);
    };
  }, []);

  return null;
};

export default SEO;
